import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ThemeProvider } from './context/ThemeContext';
import { GuestProvider } from './context/GuestContext';
import { ThemeProviderAPI } from './context/ThemeContextAPI';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GuestProvider>
<ThemeProviderAPI>

    <ThemeProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </ThemeProvider>
</ThemeProviderAPI>
    </GuestProvider>
  </React.StrictMode>
);

reportWebVitals();
